






































































































































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { Produto } from '@/models'
import { FinalizarImportacaoDeNotaDoFornecedorUseCase } from '@/usecases'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import AppStore from '@/store/vuex/aplicacao/AppStore'

@Component({
	components: {
		Confirmacao,
	},
})
export default class DialogoDeBuscarVinculoDeProdutos extends Vue {
	@Ref() confirmacaoDeVincularProduto!: Confirmacao

	finalizarImportacaoDeNotaDoFornecedorUseCase = new FinalizarImportacaoDeNotaDoFornecedorUseCase

	mostra = false
	identificador = ''
	carregando = false
	resultados: Produto[] = []
	selecionados: Produto[] = []
	indiceDoItemARelacionar = 0
	carregandoPrecoPorIndice: Record<number, boolean> = {}
	precoPorProdutoId: Record<string, number> = {}
	podeCriarProduto = false
	tipoDoFiltro = 'nomeDoProduto'

	headers = [
		{ text: 'Nome', value: 'nome', sortable: false },
		{ text: 'SKU', value: 'sku', sortable: false },
		{ text: 'Marca', value: 'marca', sortable: false },
		{ text: 'Categoria', value: 'categoria', sortable: false },
		{ text: 'Preço', value: 'preco', sortable: false },
		{ text: 'Ações', value: 'actions', sortable: false },
	]

	@Watch('selecionados')
	removerDuplicidadeDeSelecaoDeProdutos() {
		if (this.selecionados.length > 1) {
			this.selecionados = this.selecionados.slice(-1);
		}
	}

	mostrar(indiceDoItem: number, nomeDoProduto: string, podeCriarProduto){
		this.mostra = true
		this.indiceDoItemARelacionar = indiceDoItem
		this.identificador = nomeDoProduto
		this.podeCriarProduto = podeCriarProduto
		this.buscar()
	}

	esconder(){
		this.mostra = false
		this.identificador = ''
		this.resultados = []
		this.selecionados = []
		this.tipoDoFiltro = 'nomeDoProduto'
	}

	get podeBuscar(){
		return !!(this.identificador && this.identificador.trim().length > 0)
	}

	async buscar(){
		if(!this.podeBuscar) return
		try{
			this.carregando = true

			if(!this.tipoDoFiltro){
				AlertModule.setError('Necessario selecionar o tipo do filtro!')
				return
			}

			const produto = await this.finalizarImportacaoDeNotaDoFornecedorUseCase.buscarProdutosParaRelacionar(this.identificador, this.tipoDoFiltro)

			if(!produto){
				AlertModule.setInfo('Nenhum produto encontrado para o identificador informado.')
				return
			}
			this.resultados = produto
		}catch(error){
			AlertModule.setError(error)
		}finally{
			this.carregando = false
		}
	}

	async confirmarRelacionamento(){
		const vincularProduto = !!(await this.confirmacaoDeVincularProduto.mostrar());

		if(vincularProduto){
			if(this.listarGrades(this.selecionados[0]).length === 0){
				AlertModule.setError('Produto Selecionado não Possui Grade Cadastrada!')
				return
			}

			this.$emit('produtoRelacionado', this.selecionados, this.indiceDoItemARelacionar)
			this.esconder()
		}
	}

	formatarNumero(valor: number | null | undefined){
		if(valor === null || valor === undefined) return ''
		return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
	}

	formatarMensagemDeVincularProduto() {
		return `
			<div><h2 class="formatarAviso">Aviso!</h2></div>
			<div class="mt-4">
				Se confirmar, você perderá todas as alterações já realizadas 
			<span style="color: red;">exclusivamente</span> neste produto!!
			</div>
		`
	}

	obterValorDoAtributo(variante, atributoEsperado) {
		const valorFiltrado =  variante.atributosVariante.filter(atributo => atributo.nome.toUpperCase() === atributoEsperado.toUpperCase())

		if (valorFiltrado.length > 0) {
			return valorFiltrado[0].valor
		}
		return 'Sem '+atributoEsperado
	}

	get modoNoturno(){
		return AppStore.modoNoturno
	}

	listarCores(produto: Produto) {
		if (!produto) return []
		if (produto.tipo === 'Com Variantes' && Array.isArray((produto as any).variantes)) {
			const cores = (produto as any).variantes
				.map(v => this.obterValorDoAtributo(v, 'Cor'))
				.filter(v => !!v)
			return Array.from(new Set(cores))
		}
		return []
	}

	listarGrades(produto: Produto) {
		if (!produto) return []
		if (produto.tipo === 'Com Variantes' && Array.isArray((produto as any).variantes)) {
			const tamanhos = (produto as any).variantes
				.map(v => this.obterValorDoAtributo(v, 'Tamanho'))
				.filter(v => !!v)
			return Array.from(new Set(tamanhos))
		}
		return []
	}
}
